module.exports = __webpack_public_path__ + "assets/img/mecha-btn-8322f981.png";